import React from 'react';
export const C = {
  navy: '#0B2240', navy2: '#173458', navyDeep: '#071A33', gold: '#B8952E', goldL: '#D9B95E', teal: '#18B0BD',
  ink: '#1A2433', sub: '#5B677C', cream: '#F7F3E8', line: '#E6E2D8'
};
export const F = {
  serif: "'Cormorant Garamond', Georgia, serif",
  sans: "'Outfit', system-ui, sans-serif"
};
export const goldBtn = {
  background: 'linear-gradient(180deg,#D9B95E 0%,#B8912C 100%)', color: '#fff', textShadow: '0 1px 1px rgba(0,0,0,.25)', border: 0, borderRadius: 6,
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,.45),inset 0 -2px 0 rgba(0,0,0,.12),0 14px 28px -12px rgba(184,149,46,.8),0 2px 4px rgba(0,0,0,.18)',
  font: 'inherit', fontWeight: 600, fontSize: 16, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 12, padding: '18px 30px'
};
export const tealBtn = { ...goldBtn, background: 'linear-gradient(180deg,#27C8D6 0%,#149BA7 100%)', color: '#062033', textShadow: 'none', boxShadow: 'inset 0 1px 0 rgba(255,255,255,.45),inset 0 -2px 0 rgba(0,0,0,.12),0 16px 34px -12px rgba(24,176,189,.7),0 2px 4px rgba(0,0,0,.2)' };
export const input = { font: 'inherit', fontSize: 16, fontWeight: 400, color: C.ink, padding: '14px 16px', border: '1.5px solid #D9D4C8', borderRadius: 8, background: 'linear-gradient(180deg,#FBFAF7,#fff)', boxShadow: 'inset 0 2px 4px rgba(11,34,64,.07)', width: '100%' };
export const Eyebrow = ({ children, color = C.gold, center }) => (
  <p style={{ margin: '0 0 18px', color, fontSize: 12, letterSpacing: '.22em', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: center ? 'center' : 'flex-start', gap: 14 }}>
    <span style={{ width: 34, height: 1, background: color, display: 'inline-block', flex: 'none' }} />{children}{center && <span style={{ width: 34, height: 1, background: color, display: 'inline-block', flex: 'none' }} />}
  </p>
);
// CRA port: campaign assets live under /campaign52/ in public (route stays /52).
export const asset = (p) => '/campaign52/' + p.replace(/^\//, '');

export const BP = { mobile: 720, tablet: 1024 };

export function useWidth() {
  const query = React.useCallback(
    () => (typeof window === 'undefined'
      ? { mobile: false, tablet: false }
      : { mobile: window.innerWidth < BP.mobile, tablet: window.innerWidth < BP.tablet }),
    []
  );
  const [bp, setBp] = React.useState(query);
  React.useEffect(() => {
    const mqM = window.matchMedia(`(max-width:${BP.mobile - 1}px)`);
    const mqT = window.matchMedia(`(max-width:${BP.tablet - 1}px)`);
    const sync = () => setBp((p) =>
      p.mobile === mqM.matches && p.tablet === mqT.matches
        ? p
        : { mobile: mqM.matches, tablet: mqT.matches });
    sync();
    mqM.addEventListener('change', sync);
    mqT.addEventListener('change', sync);
    return () => { mqM.removeEventListener('change', sync); mqT.removeEventListener('change', sync); };
  }, []);
  return { w: typeof window === 'undefined' ? 1280 : window.innerWidth, mobile: bp.mobile, tablet: bp.tablet };
}
